import React from 'react';

import { IconFeatured } from '../Icons';
import { StyledWrapper } from './CustomCollectionFeaturedBadgeStyles';

var _ref = React.createElement(
  StyledWrapper,
  null,
  React.createElement(IconFeatured, null)
);

var CollectionFeatured = function CollectionFeatured() {
  return _ref;
};

export default React.memo(CollectionFeatured);